import React from 'react';
import { ProductOrderFormErrors } from './validation';
import {
    FormattedMessage,
    injectIntl,
    useIntl,
    WrappedComponentProps,
} from 'react-intl';
interface IErrorsMessageBox {
    errors: ProductOrderFormErrors;
}

const ErrorsMessageBox = ({ errors }: IErrorsMessageBox) => {
    const intl = useIntl();
    const errorMessages: string[] = [];

    Object.keys(errors).map((x) => {
        if (!errorMessages.includes((errors as any)[x]))
            errorMessages.push((errors as any)[x]);
    });

    return (
        errors && (
            <>
                <div className="alert alert-danger">
                    <div className="row row-m-b" style={{ padding: '10px' }}>
                        <strong>
                            {' '}
                            <FormattedMessage
                                id="The_following_information_is_required"
                                defaultMessage="The following information is required before you can
                            continue"
                            />
                            :
                        </strong>
                        <ul
                            style={{
                                listStyleType: 'disc',
                                paddingLeft: '30px',
                            }}
                        >
                            {errorMessages.map((x) => {
                                if (x)
                                    return (
                                        <li
                                            key={x}
                                            className="col-sm-12"
                                            style={{ padding: '2px' }}
                                        >
                                            {intl.formatMessage({
                                                id: x
                                                    .split(' is required')[0]
                                                    .replace(/ /g, '_'),
                                                defaultMessage:
                                                    x.split(' is required')[0],
                                            })}
                                        </li>
                                    );
                            })}
                        </ul>
                    </div>
                </div>
            </>
        )
    );
};

export default ErrorsMessageBox;
